import { Utils } from './utils';
/** Global boolean for tracking if the site has done its leading check yet or not. */
let hasSiteLoaded = false;
/** Variable for the callback function to be put into for running after running function is complete. */
let removeLoadListeners = null;
// Setup the load event listeners for the given callback function.
removeLoadListeners = Utils.SetupLoadEventListener(loadExternalJs);
/**
 * When this function runs, as long as the function has not previously ran before, add the pageLoad.bundle.js
 * file to the site's DOM.
 * @returns
 */
function loadExternalJs() {
    var _a;
    // Ensure this function has not already ran.
    if (hasSiteLoaded)
        return;
    hasSiteLoaded = true;
    // reuse the exact hashed URL the server already rendered on the preload link
    const preload = document.querySelector('link[rel="preload"]#preload-pageloadedjs');
    const src = preload ? preload.href
        : '/dist/js/pageLoaded.bundle.js?t=' + Date.now();
    const pageNonce = (_a = document.querySelector('script[nonce]')) === null || _a === void 0 ? void 0 : _a.nonce;
    // Create script to be injected into the DOM
    let script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (pageNonce)
        script.nonce = pageNonce;
    // Add Script to DOM
    document.getElementsByTagName('body')[0].appendChild(script);
    // Remove excess event listeners
    removeLoadListeners === null || removeLoadListeners === void 0 ? void 0 : removeLoadListeners();
}
